import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from "react-router";
import { ColorSchemeScript, MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
export default function Layout() {
    return _jsxs(MantineProvider, { defaultColorScheme: "light", children: [_jsx(ColorSchemeScript, {}), _jsx(Outlet, {})] });
}
